export default __webpack_public_path__ + "static/SelfApp_banner-0319452ae870077334f3e6e786902f6b.jpg";